import emptyImgh5 from "@/components/publick/emptyImgh5.vue";
import emptyImgPc from "@/components/publick/empty/emptyImgPc.vue";
import H5ToothMap from "@/components/publick/h5toothmap.vue";
import PLoading from "@/components/publick/loading.vue";

// PC端公共组件
import PcTopSearch from "@/components/pc/public/table/topSearch.vue";
import PcPagination from "@/components/pc/public/table/pagination.vue";
import PcInput from "@/components/pc/public/pcInput.vue";
import PcSelect from "@/components/pc/public/pcSelect.vue";
import VirtualPcSelect from "@/components/pc/public/virtualPcSelect.vue";
import PcDeptSelect from "@/components/pc/public/pcDeptSelect.vue";
import PcDialog from "@/components/pc/public/pcDialog.vue";
import PcDateTypeSelector from "@/components/pc/public/dateTypeSelector.vue";
import PcDmyDateSelector from "@/components/pc/public/dmyDateSelector.vue";
import InputTypeSelector from "@/components/pc/public/inputTypeSelector.vue";
import PcDrawer from "@/components/pc/public/pcDrawer.vue";
import SearchFor from "@/components/pc/public/searchfor.vue";
import TableInputAutoComplete from "@/components/pc/public/tableinputAutoComplete.vue";
import PCSelectTag from "@/components/pc/public/selectTag.vue";
import VerticalTabSwitch from "@/components/pc/public/VerticalTabSwitch.vue";
import textMore from "@/components/pc/public/textMore.vue";
import SelectClinicDialog from "@/components/pc/public/SelectClinicDialog.vue";
import SelectEmployeeDialog from "@/components/pc/public/SelectEmployeeDialog.vue";
import YGJDeptCascader from "@/components/pc/public/YGJDeptCascader.vue";
//如果是PC用PC开头 如果是H5用H5开头

export default {
  install(app) {
    // 公共组件
    app.component("EmptyImgh5", emptyImgh5);
    app.component("EmptyImgPc", emptyImgPc);
    app.component("H5ToothMap", H5ToothMap);
    app.component("PLoading", PLoading);

    // PC端公共组件
    app.component("PcTopSearch", PcTopSearch);
    app.component("PcPagination", PcPagination);
    app.component("PcInput", PcInput);
    app.component("PcSelect", PcSelect);
    app.component("VirtualPcSelect", VirtualPcSelect);
    app.component("PcDeptSelect", PcDeptSelect);
    app.component("PcDateTypeSelector", PcDateTypeSelector);
    app.component("PcDmyDateSelector", PcDmyDateSelector);
    app.component("InputTypeSelector", InputTypeSelector);
    app.component("PcDialog", PcDialog);
    app.component("PcDrawer", PcDrawer);
    app.component("SearchFor", SearchFor);
    app.component("TableInputAutoComplete", TableInputAutoComplete);
    app.component("PCSelectTag", PCSelectTag);
    app.component("PcTextmore",textMore);
    app.component("PcVerticalTabSwitch", VerticalTabSwitch);
    app.component("PcSelectClinicDialog", SelectClinicDialog);
    app.component("PcSelectEmployeeDialog", SelectEmployeeDialog);
    app.component("YGJDeptCascader", YGJDeptCascader);
  },
};
 